import type { Provider } from '@angular/core';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable()
export class ComponentTooltipResizeConsumer extends Observable<void> {
  constructor() {
    super();
  }
}

@Injectable()
export class ComponentTooltipResizeDispatcher
  extends Subject<void>
  implements ComponentTooltipResizeConsumer {}

export const COMPONENT_TOOLTIP_RESIZE_PROVIDERS: Provider[] = [
  ComponentTooltipResizeDispatcher,
  {
    provide: ComponentTooltipResizeConsumer,
    useExisting: ComponentTooltipResizeDispatcher,
  },
];
